import { Checkbox } from '@mantine/core';
import type { ColumnDef } from '@tanstack/react-table';
import type { RouterOutputs } from '~/trpc-extra/api';

export const tagColumns: ColumnDef<RouterOutputs['tag']['list'][number]>[] = [
  {
    id: 'select',
    enableSorting: false,
    enableHiding: false,
    size: 0,
    header: ({ table }) => (
      <Checkbox
        role="none"
        size="xs"
        checked={table.getIsAllPageRowsSelected()}
        onChange={table.getToggleAllPageRowsSelectedHandler()}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        size="xs"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },
  {
    accessorFn: (row) => row.name,
    id: 'Name',
    header: 'Name',
    cell: ({ row }) => <div>{row.original.name}</div>,
    size: 250,
  },
  {
    accessorFn: (row) => row._count.testV2s,
    id: 'Test Count',
    header: 'Test Count',
    cell: ({ row }) => <div>{row.original._count.testV2s}</div>,
    size: 100,
  },
];
